import React from 'react';
import { HashRouter, Route } from 'react-router-dom';

import { RouteWithLayout } from '@components';

// Layouts
import { Main } from 'layouts';

// Views
import {
  Home,
  HomeExternal,
  Login,
  NoticePrivacy,
  ProfileSettings,
  UnlockUser,
  WelcomePassword,
} from 'views';

const Routes = () => {
  return (
    <>
      <div id="loading-bar" style={{ position: 'absolute' }}></div>

      <HashRouter>
        {/* Not Required Authorization */}
        <Route
          exact
          path="/login"
          component={Login}
        />
        <Route
          exact
          path="/bienvenida"
          component={WelcomePassword}
        />
        <Route
          exact
          path="/cambiar-password"
          component={WelcomePassword}
        />
        <Route
          exact
          path="/unlock-user"
          component={UnlockUser}
        />
        <Route
          exact
          path="/notice-privacy"
          component={NoticePrivacy}
        />
        <RouteWithLayout
          exact
          path="/home"
          layout={Main}
          component={Home}
          state={{ backButton: false }}
        />
        <RouteWithLayout
          exact
          path="/"
          layout={Main}
          component={Home}
          state={{ backButton: false }}
        />
        <RouteWithLayout
          exact
          path="/bienvenida/externo"
          layout={Main}
          component={HomeExternal}
        />
        <RouteWithLayout
          exact
          path="/configuraperfil"
          layout={Main}
          component={ProfileSettings}
          state={{ backButton: true, backRoute: '/home' }}
        />
      </HashRouter>
    </>
  );
};

export default Routes;
